<script setup lang="ts">
import { Button, Icon } from "@/components/Ui";
import { BlockPrivateCashback, BlockPrivateFreeCards } from "@/components/Blocks";
import { onDashboard } from "@/helpers/events";
import { onMounted, ref } from "vue";
import { getPrivateQueryParam } from "~/helpers/private";

const { t } = useI18n();
const isReady = ref<boolean>(false);
onMounted(() => {
  isReady.value = true;
});
</script>
<template>
  <div
    :class="$style.root"
    class="container"
  >
    <Transition name="fade-slide-up-private">
      <div v-show="isReady">
        <h1 class="mt-5" ref="titleEl" :class="[$style[`root-title`], $style[`root-title-${$i18n.locale}`]]">
          {{ $t("block.heroPrivate.cashbackHero") }}</h1>
        <p :class="$style['root-sub-title']" class="mt-5">{{ $t("block.heroPrivate.cashbackSubHero") }}</p>
        <div
          ref="buttonEl"
          :class="$style[`root-content`]"
          class="mt-5"
        >
          <Button
            :title="$t('btn.joinToPstPriivate')"
            color="orange"
            :class="$style[`root-button`]"
            @click="
          onDashboard(
            'landing_privat_button-1',
            `/register?${getPrivateQueryParam()}`,
            {},
            {},
            true
          )
        "
          />
        </div>

        <div :class="$style['root-wrapper-hero-icon']" class="max-w-[581px] max-h-[504px]">
          <Icon
            name="private-hero-cards"
            path="pattern"
            class="w-full"
          />
        </div>

      </div>
    </Transition>

    <div :class="$style.blocks">
      <transition name="fade-slide-up-private" appear>
        <BlockPrivateCashback v-show="isReady" />
      </transition>
      <transition name="fade-slide-up-private" appear>
        <BlockPrivateFreeCards v-show="isReady" />
      </transition>
    </div>
  </div>
</template>

<style lang="scss" module>
.root {
  @apply flex flex-col items-center overflow-x-hidden;

  /*@apply pt-6 xs:pt-12 md:pt-20 lg:py-4 w-full gap-[40px] lg:min-h-[calc(100vh-80px)] lg:justify-center;*/
  &-sub-title {
    color: #FFF;
    text-align: center;
    font-family: ALS Granate VF;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  &-wrapper-hero-icon {
    z-index: -1 !important;
    position: relative;
    margin: -65px auto;
  }

  &-title {
    @apply text-center pb-1;
    font-style: normal;
    font-weight: 850;
    line-height: 100%;
    background: linear-gradient(180deg, #E7CCA5 0%, #15191D 112.88%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    &-be,
    &-bg,
    &-ua,
    &-zh,
    &-bg,
    &-ru,
    &-ja,
    &-th,
    &-pl,
    &-hi,
    &-ar,
    &-bn,
    &-ko,
    &-vi,
    &-sw,
    &-en,
&-id,
&-da,
&-et,
&-hu,
&-lt,
&-nb,
&-ro,
&-sl,
&-cs,
&-el,
&-fi,
&-lv,
&-nl,
&-sk,
&-sv,
&-he,
    &-tr,
    &-pt,
    &-it,
    &-es,
    &-fr {
      @apply text-[52px] xxs:text-[62px] md:text-[76px];
    }

    &-de {
      @apply text-[46px] xxs:text-[52px] 414:text-[62px] md:text-[76px];
    }

    &-zh,
    &-ja {
      @apply leading-[1.1];
    }
  }

  &-content {
    @apply flex flex-col items-center gap-4 w-full max-w-[440px] mx-auto;
  }

  &-button {
    @apply w-full 414:w-fit min-w-[274px] mx-auto h-[48px];

    color: var(--neutral-n-0, #FFF);
    text-align: center;

    /* 15/480 */
    font-family: ALS Granate VF;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 160% */
  }
}

.blocks {
  @apply grid grid-cols-1 md:grid-cols-2 gap-[10px] w-full;
}
</style>
